module.exports = __webpack_public_path__ + "static/media/appsplash.9783399b.png";